import React from "react";
import { BANCO_ENUM_PURPOSE } from "banco/constants/generated/constants";

interface PurposeSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export const PurposeSelector: React.FC<PurposeSelectorProps> = ({ value, onChange }) => {
  return (
    <select
      className="form-control"
      name="purpose"
      data-fb-input="purpose"
      value={ value }
      onChange={ (e) => onChange(e.target.value) }
    >
      <option value="">Purpose</option>
      { Object.entries(BANCO_ENUM_PURPOSE).map(([key, label]) => (
        <option key={ key } value={ label }>
          { label }
        </option>
      )) }
    </select>
  );
};
